// @ts-check

export class PlatformAdapter {
  haptic(enabled = true) {
    if (enabled && navigator.vibrate) navigator.vibrate(18);
  }
  async share(data) {
    if (navigator.share) {
      await navigator.share(data);
      return "shared";
    }
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(data.text ?? data.url ?? "");
      return "copied";
    }
    return "unavailable";
  }
  onBackground(callback) {
    const handler = () => {
      if (document.visibilityState === "hidden") callback();
    };
    document.addEventListener("visibilitychange", handler);
    return () => document.removeEventListener("visibilitychange", handler);
  }
}
